import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import easymembr from "./../components/images/Easy-MembrLogo.png";
import membrmanage from "./../landingpage/assets/images/member.png";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import {
    checkEmail,
    createGBussinessInfo,
    getGBussinessInfo,
    getSubscriptionPlans,
    saveGBussinessInfo,
    getManagementPricingPlans,
    createmgmtSubscription,
    createOrderSubscriptionmgmtPlan,
    getmgmtSubscriptionByGymId,
    numberSignUp,
    sendVEmail,
    getAllPricingPlans
} from "../services/apiServices.js";
import { MDBAlert, MDBBtn, MDBCheckbox, MDBCol, MDBIcon, MDBPopover, MDBPopoverBody, MDBPopoverHeader, MDBRow, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead, MDBTooltip, } from "mdb-react-ui-kit";
import { isEmail, isEmpty, } from "../validators/helper.js";
import moment from "moment";
import Popup from "../components/Popup";
import PlanPopup from "./subscriptionplanpopup.js";


export default function BillingSubscriptionMagmntPlan() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const planId = params.get('id');
    const planTimePeriod = params.get('value');
    const getplanName = params.get('name'); 
    const showpopup = params.get('show');
    const gettestparms = params.get('test') || null;
    useEffect(() => {
        if (planId || getplanName || showpopup) {
            navigate(location.pathname, { replace: true });
        }
    }, []);
    const [plansData, setPlansData] = useState({});
    const [ErrorBusinessInfo, setErrorBusinessInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [allSubscription, setAllSubscription] = useState([]);
    const [centredModal, setCentredModal] = useState(false);
    const [centredModal1, setCentredModal1] = useState(false);
    const [centredModal2, setCentredModal2] = useState(true);
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const otpRefs = useRef([]);
    const [resendTimer, setResendTimer] = useState(30); // seconds
    const [error, setError] = useState("");
    const [notp, setNotp] = useState("");
    const [emailVerify, setEmailVerify] = useState(false);
    const [selectedOption, setSelectedOption] = useState(1);
    const [prevBalanceAmount, setPrevBalanceAmount] = useState(0)
    const [balAmnt, setBalAmnt] = useState(0);
    const [Form, setForm] = useState({
        planid: "",
        amount: 0,
        smsintergration: true,
        accountantrole: true,
        whatsappintegration: true,
        memberportal: false,
        subscriptionfrequency: 0,
        autopay: true,
        currency: "INR",
        paylater: false,
        extramonths: 0,
        ptype: 1,
        extenddays: 0,
        lifetimefree: false,
    });
    const [businessForm, setbusinessForm] = useState({
        businessName: "",
        businessEmail: "",
        firstName: "",
        lastName: "",
        contactNumber: "",
        address: "",
        city: "",
        gstnumber: "",
        isnumberverified: false,
        isemailverified: false,
    });
    const [coupon, setCoupon] = useState({
        couponCode: "",
        couponApplied: false,
        couponError: "",
        discountPercentage: 0,
        extraDays: 0,
    });


    const coupons = [
        { code: "EASY30", extraDays: 30, discountPercentage: 10, validUntil: "2025-08-31" },
        { code: "WELCOME20", extraDays: 15, discountPercentage: 20, validUntil: "2025-09-15" },
        { code: "SUMMER50", extraDays: 45, discountPercentage: 50, validUntil: "2025-07-30" }
    ];

    const applyCoupon = () => {
        if (!coupon.couponCode || coupon.couponCode.trim() === "") {
            setCoupon(prev => ({
                ...prev,
                couponApplied: false,
                extraDays: 0,
                discountPercentage: 0,
                couponError: "Please enter a coupon code.",
            }));
            return;
        }
        const matchedCoupon = coupons.find(
            c => c.code === coupon.couponCode.trim()
        );

        if (matchedCoupon) {
            const today = new Date();
            const expiryDate = new Date(matchedCoupon.validUntil);
            if (today > expiryDate) {
                setCoupon(prev => ({
                    ...prev,
                    couponApplied: false,
                    extraDays: 0,
                    discountPercentage: 0,
                    couponError: "This coupon has expired.",
                }));
                return;
            }

            setCoupon(prev => ({
                ...prev,
                discountPercentage: matchedCoupon.discountPercentage,
                extraDays: matchedCoupon.extraDays,
                couponCode: matchedCoupon.code,
                couponApplied: true,
                couponError: "",
                showInput: false,
            }));
        } else {
            setCoupon(prev => ({
                ...prev,
                couponApplied: false,
                extraDays: 0,
                discountPercentage: 0,
                couponError: "Invalid coupon code",
            }));
        }
    }
    const navigate = useNavigate();

    function updateBusinessForm(value) {
        return setbusinessForm((prev) => {
            return { ...prev, ...value };
        });
    }
    useEffect(() => {
        if (showpopup === "0") {
            setCentredModal2(false);
        }
    }, [showpopup])
    async function fetchPData() {
    
        let allData = [];

        const resp = await getSubscriptionPlans(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!resp || resp === "false") return;

        const respRe = await resp.json();

        if (respRe.length > 0) {
            allData = allData.concat(respRe);
        }


        if (allData.length > 0) {
            let filterSubscription = allData.sort(
                (a, b) => new Date(b.subscriptionexpirydate) - new Date(a.subscriptionexpirydate)
            );
            setAllSubscription(filterSubscription);
        }
    }
    const finalAmount = coupon.couponApplied
        ? Form.amount - (Form.amount * (coupon.discountPercentage / 100))
        : Form.amount;

    let totalAmount = (((finalAmount) * 1.18)) || 0;
    let payAmount = Number(Form.paylater ? 0 : (totalAmount - prevBalanceAmount).toFixed(2));

    useEffect(() => {
        if (localStorage.getItem("number")) {
            updateBusinessForm({ contactNumber: localStorage.getItem("number") });
            localStorage.removeItem("number");
        }
        async function fetchData() {

            const response = await getGBussinessInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response == 'false') {
                return;
            }
            const data = await response.json();
            console.log(data)
            setbusinessForm((prev) => ({
                ...prev,
                businessName: data.businessName,
                businessEmail: data.businessEmail,
                firstName: data.firstName,
                lastName: data.lastName,
                contactNumber: data.contactNumber,
                address: data.address,
                city: data.city,
                gstnumber: data.gstnumber,
                istesting: data.istesting,
                isnumberverified: data?.isnumberverified || false,
                isemailverified: data?.isemailverified || false,
            }));
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData();
            fetchPData();
        }
    }, []);

    function generateUniqueKey(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let uniqueKey = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueKey += characters.charAt(randomIndex);
        }
        return uniqueKey;
    }
    let validateForm = (e) => {
        let errors = {};
        if (isEmpty(businessForm.businessName)) {
            errors.businessName = "Please enter your business name.";
        }
        if (isEmpty(businessForm.firstName)) {
            errors.firstName = "Please enter your first name.";
        }
        if (isEmpty(businessForm.lastName)) {
            errors.lastName = "Please enter your last name.";
        }
        if (isEmpty(businessForm.businessEmail)) {
            errors.businessEmail = "Please enter your email address.";
        } else if (!isEmail(businessForm.businessEmail)) {
            errors.businessEmail = "Please enter a valid email address.";
        } 
        // else if (!businessForm.isemailverified) {
        //     errors.businessEmail = "Please verify your email address.";
        // }
        if (isEmpty(businessForm.contactNumber)) {
            errors.contactNumber = "Please enter your mobile number.";
        } else if (!businessForm.isnumberverified && !gettestparms) {
            errors.verify = "Please verify your mobile number.";
        }
        if (isEmpty(businessForm.address)) {
            errors.address = "Please enter your address.";
        }
        if (isEmpty(businessForm.city)) {
            errors.city = "Please enter your city.";
        }

        return isEmpty(errors) ? true : errors;
    };
    async function checkingEmail() {
        if (localStorage.getItem("loggedUserInfo")) {
            return true;
        }
        let id = "1";
        let obj = {
            email: businessForm.businessEmail,
        }
        const res = await checkEmail(id, obj);
        const resObj = await res.json();
        console.log(resObj)
        if (resObj?.error) {
            setErrorBusinessInfo({ businessEmail: "Email already exists." });
            return false;
        } else {
            return true;
        }
    }
    function payNow(e) {
        let errors = validateForm(e);
        if (errors === true) {
            setLoading(true);
            setErrorBusinessInfo({});
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const timeString = hours + minutes;
            if (payAmount <= 0) {
                payNowHandler(null);
            } else if (gettestparms && (gettestparms == timeString)) {
                payNowHandler(null);
            } else {
                // payNowHandler(null);
                handleNewPayment();
            }
        } else {
            setErrorBusinessInfo(errors);
        }
    }
    let currentPlan = plansData.length > 0 ? (plansData.find((obj) => obj._id == Form.planid)) : null;
    async function payNowHandler(response) {
        try {
            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
            if (localStorage.getItem("loggedUserInfo")) {
                const updates = {
                    businessName: businessForm.businessName,
                    businessEmail: businessForm.businessEmail,
                    firstName: businessForm.firstName,
                    lastName: businessForm.lastName,
                    contactNumber: businessForm.contactNumber,
                    address: businessForm.address,
                    city: businessForm.city,
                    isnumberverified: businessForm.isnumberverified,
                    isemailverified: businessForm.isemailverified,
                };
                await saveGBussinessInfo(updates, gymid);
            } else {
                const uniqueId = generateUniqueKey(8);
                const updates = {
                    firstname: businessForm.firstName,
                    lastname: businessForm.lastName,
                    businessName: businessForm.businessName,
                    email: businessForm.businessEmail,
                    address: businessForm.address,
                    city: businessForm.city,
                    password: uniqueId,
                    through: "subscription",
                    number: businessForm.contactNumber,
                    isnumberverified: businessForm.isnumberverified,
                    isemailverified: businessForm.isemailverified,
                };
                const saverep = await createGBussinessInfo(updates);
                const jsOBj = await saverep.json();
                console.log(jsOBj)
                if (jsOBj.userInfo) {
                    gymid = jsOBj.userInfo.gymid;
                }
            }
            let modules = {
                smsintergration: true,
                whatsappintegration: true,
                isfreetrail: false,
                lifetimefree: Form.lifetimefree,
            };
            let couponObj = {
                couponCode: coupon.couponCode,
                discountPercentage: coupon.discountPercentage,
                extraDays: coupon.extraDays,
            }
            let updateObj = {
                planid: Form.planid,
                gymid: gymid,
                amount: Math.round(totalAmount),
                payamount: payAmount,
                currency: Form.currency || "INR",
                response,
                coupon: coupon.couponApplied ? couponObj : null,
                subscriptionfrequency: Form.subscriptionfrequency,
                autopay: Form.autopay,
                addons: modules,
                extramonths: Form.extramonths,
                paylater: Form.paylater,
                planextend: selectedOption,
                extenddays: Form.extenddays,
            }
            const reqObj = await createmgmtSubscription(updateObj);
            if (!reqObj || reqObj == 'false') {
                return;
            }
            setLoading(false);
            const resObj = await reqObj.json();
            console.log(resObj);
            localStorage.removeItem("landingpageinfo");
            let url = "/login";
            if (localStorage.getItem("loggedUserInfo")) {
                navigate(url);
            } else {
                navigate(`${url}?value=true`);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }
    useEffect(() => {
        async function fetchData() {
            const response = await getAllPricingPlans();
            if (!response || response === 'false') {
                return;
            }
            let recinfo = await response.json();
            if (recinfo) {
                let plans = recinfo;
                let filterPlan = plans.find((obj) => obj._id == planId);
                if (!filterPlan) {
                    let otherPlans = getplanName != null ? plans.find((obj) => obj.name.toLowerCase().includes(getplanName.toLowerCase())) : null;
                    if (otherPlans?.name) {
                        filterPlan = otherPlans;
                    } else {
                        let plan = plans.filter((obj) => obj.availability === true);
                        filterPlan = plan?.[plan.length - 1];
                    }
                }
                let index = 0;
                if (filterPlan?.billingperiod && (filterPlan?.billingperiod?.length > 0 && filterPlan?.billingperiod?.length > 1)) {
                    if (planTimePeriod == 1) {
                        index = 1;
                    }
                }
                let frequency = filterPlan?.billingperiod ? filterPlan.billingperiod[index]?.duration : 0;
                let montlyAmount = filterPlan?.billingperiod ? filterPlan.billingperiod[index]?.montly : 0;
                let lifetimeFree = filterPlan?.billingperiod.filter((obj) => !obj.entity)?.length > 0 ? false : true;
                setForm(prevForm => ({
                    ...prevForm,
                    planid: filterPlan?._id || "",
                    subscriptionfrequency: frequency,
                    amount: montlyAmount * frequency,
                    lifetimefree: lifetimeFree,
                }));
                setPlansData(plans);
            }
        }
        fetchData();
    }, []);
    const selectPlan = (planid, duration) => {
        setForm(prevForm => ({
            ...prevForm,
            planid: planid,
            subscriptionfrequency: duration,
        }));
        setCentredModal2(false);
    }
  
    useEffect(() => {
        if (plansData.length > 0) {
            let planObj = plansData.find((obj) => obj._id === Form.planid);
            if (!planObj) {
                return;
            }
            let frequency = Form.subscriptionfrequency;
            let planPrice = planObj.billingperiod.find((obj) => obj.duration == frequency)?.montly || 0;
            let lifetimeFree = planObj.billingperiod.filter((obj) => !obj.entity)?.length > 0 ? false : true;
            let totalPrice = (planPrice * frequency);
            setForm((prevForm) => ({
                ...prevForm,
                amount: totalPrice,
                lifetimefree: lifetimeFree,
            }));
        }
    }, [
        Form.planid,
        Form.subscriptionfrequency,
        plansData.pricingPlans,
        coupon.couponApplied,
    ]);

    let expiryDate = new Date();
    if (allSubscription.length > 0) {
        const filterSubscription = allSubscription.filter((obj) => obj.status == 1 && !obj?.plandetails?.lifetimefree);
        if (filterSubscription.length > 0 && selectedOption == 1 && (new Date(filterSubscription[0]?.subscriptionexpirydate) > new Date())) {
            expiryDate = new Date(filterSubscription[0]?.subscriptionexpirydate);
        }
    }
    const Difference = (expiryDate - new Date()) / (1000 * 60 * 60 * 24);
    console.log("endDate difference:", Difference);
    const dayDifference = moment(expiryDate).diff(moment(), 'days');
    let extenddays = Number((selectedOption == 1 && (Math.floor(dayDifference) > 0)) ? dayDifference : 0) + Number(Form.extenddays);

    let addmonths = Number(Form.extramonths) + Number(Form.subscriptionfrequency);

    if (Form.paylater == true && Form.extramonths > 0) { // extra montha paylater
        addmonths = Form.extramonths;
    }

    let expirydate = moment(expiryDate).add(addmonths, 'months').toDate();
    if (Form.extenddays > 0) {
        expirydate = moment(new Date(expirydate)).add(Form.extenddays, 'days').toDate();
    }
    if (coupon?.extraDays > 0) {
        expirydate = moment(new Date(expirydate)).add(coupon?.extraDays, 'days').toDate();
    }

    const formattedExpiryDate = moment.utc(expirydate).format('MMM D, YYYY');
    const formattedStartDate = moment.utc(expiryDate).format('MMM D, YYYY');

    useEffect(() => {
        if (allSubscription.length === 0) return;
        const filterSubscription = allSubscription.filter((obj) => obj.status == 1 && !obj?.plandetails?.lifetimefree);
        if (filterSubscription.length === 0) return;

        // const filterSubscriptionCurrentPlan = filterSubscription.filter((obj) => obj.subscriptionexpirydate >= new Date() && obj.subscriptionstartdate <= new Date());
        filterSubscription.sort((a, b) => new Date(b.subscriptionexpirydate) - new Date(a.subscriptionexpirydate));
        const latestSubscription = filterSubscription[0];
        console.log("latestSubscription.planid:", latestSubscription.planid);
        console.log("Current Planid:", Form.planid);
        if (Form.planid !== latestSubscription.planid) {
            if (Form.lifetimefree === true) {
                setBalAmnt(0);
                setSelectedOption(0);
                setForm(prevForm => ({
                    ...prevForm,
                    extenddays: 0,
                }));
                setPrevBalanceAmount(0);
                return;
            }
            // Plan upgrade/downgrade logic
            const activeSubscriptions = allSubscription.filter(sub => sub.status == 1 &&
                (new Date(sub.subscriptionexpirydate) > new Date()) && (sub?.amount > 0)
            );

            let previousBalance = 0;
            for (const sub of activeSubscriptions) {
                const expiry = new Date(sub.subscriptionexpirydate);
                const start = new Date(sub.subscriptionstartdate);
                const totalDurationDays = (expiry - start) / (1000 * 60 * 60 * 24);
                const remainingDays = (expiry - new Date()) / (1000 * 60 * 60 * 24);
                const remainingAmount = (remainingDays * (sub.amount)) / totalDurationDays;
                previousBalance += remainingAmount;
            }
            console.log("previousBalance:", previousBalance);
            console.log("totalAmount", totalAmount);
            setBalAmnt(previousBalance);
            if (totalAmount < previousBalance) {
                // User has extra balance — calculate extend days
                setPrevBalanceAmount(totalAmount);

                const balanceDifference = previousBalance - totalAmount;
                console.log("balanceAmountDifference:", balanceDifference)
                const today = new Date();
                const estimatedEndDate = new Date(today);
                estimatedEndDate.setMonth(today.getMonth() + Number(Form.subscriptionfrequency));

                const durationDays = Math.floor((estimatedEndDate - today) / (1000 * 60 * 60 * 24)) || 1; // prevent division by zero
                const perDayCurrentPlanAmount = totalAmount / durationDays;
                console.log("perDayCurrentPlanAmount", perDayCurrentPlanAmount);
                const extendDays = balanceDifference / perDayCurrentPlanAmount;
                console.log("extendDays", extendDays);
                setForm(prevForm => ({
                    ...prevForm,
                    extenddays: extendDays,
                }));
            } else {
                setPrevBalanceAmount(previousBalance);
                setForm(prevForm => ({
                    ...prevForm,
                    extenddays: 0,
                }));
            }
            previousBalance = 0;
            setSelectedOption(2); // Plan upgrade/downgrade
        } else {
            // Same plan renewal logic
            setSelectedOption(1);
            setBalAmnt(0);
            setForm(prevForm => ({
                ...prevForm,
                extenddays: 0,
            }));
            setPrevBalanceAmount(0);
        }

    }, [Form.planid, Form.amount, Form.lifetimefree, coupon.couponApplied]);
    const handleNewPayment = async () => {

        let updates = {
            amount: payAmount,
            currency: Form.currency,
            gymid: JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid || null
        };

        const response = await createOrderSubscriptionmgmtPlan(updates);
        const order = await response.json();

        console.log(order);
        const options = {
            key: order.merchantkey,
            amount: order.amount,
            currency: order.currency,
            name: "EASYMEMBR",
            description: "Payment for Subscription Plan",
            order_id: order.id,
            // customer_id: id,
            handler: async function (response) {
                console.log(response);
                try {
                    payNowHandler(response);
                } catch (error) {
                    console.log(error)
                }
            },
            modal: {
                ondismiss: function () {
                    setLoading(false);
                }
            }
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
    };
    const otpfield = async (e) => {
        e.preventDefault();
        const response = await numberSignUp({ phone: businessForm.contactNumber, value: !localStorage.getItem("loggedUserInfo") });
        let resData = await response.json();
        console.log(resData);
        if (resData.status != 200) {
            setError(resData.status === 400 ? "Please try again." : "Number already exits in the system!")
        } else {
            setError("OTP Sent Successfully");
            setCentredModal(true);
            setResendTimer(30);
            setNotp(resData.otp);
            setOtpDigits(Array(6).fill(""));
            otpRefs.current.forEach((input) => { if (input) input.value = ""; });
            setTimeout(() => { otpRefs.current[0]?.focus(); }, 100);
            setTimeout(() => { setNotp("") }, 300000);
        }
    }
    const handleOtpChange = (e, index) => {
        const value = e.target.value.replace(/[^0-9]/g, "");

        if (value) {
            const newOtp = [...otpDigits];
            newOtp[index] = value;
            setOtpDigits(newOtp);
            if (index < otpDigits.length - 1) {
                otpRefs.current[index + 1]?.focus();
            }
        }
    };
    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newOtp = [...otpDigits];
            if (otpDigits[index]) {
                // Clear current box
                newOtp[index] = "";
                setOtpDigits(newOtp);
            } else if (index > 0) {
                // Move back and clear
                otpRefs.current[index - 1]?.focus();
                newOtp[index - 1] = "";
                setOtpDigits(newOtp);
            }
        } else if (e.key === "ArrowLeft" && index > 0) {
            otpRefs.current[index - 1]?.focus();
        } else if (e.key === "ArrowRight" && index < otpDigits.length - 1) {
            otpRefs.current[index + 1]?.focus();
        }
    };
    useEffect(() => {
        if (resendTimer === 0) return;
        const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
        return () => clearInterval(timer);
    }, [resendTimer]);

    const handleVerifyOTP = (e) => {
        const enteredOTP = otpDigits.join("");
        if (notp == "") {
            setError("Your OTP has expired. Please request a new one to continue.");
        } else if (enteredOTP !== notp) {
            setError("Invalid OTP.Please try again.");
        }
        else {
            setError("OTP verified Successfully. ");
            setCentredModal(false);
            updateBusinessForm({ isnumberverified: true });
        }
    };
    const handleOtp = (e) => {
        e.preventDefault();
        if (isEmpty(businessForm.contactNumber)) {
            setErrorBusinessInfo({ contactNumber: "Field can't be blank" });
        } else if (!isValidPhoneNumber(businessForm.contactNumber)) {
            setError("Please enter valid contact number!");
            setErrorBusinessInfo({ contactNumber: "Please enter valid contact number!" });
        } else {
            setErrorBusinessInfo({});
            if (notp == "") {
                otpfield(e)
            } else {
                setCentredModal(true);
            }
        }
    };
    const emailVerifyHandler = async (e) => {
        e.preventDefault();
        let val = await checkingEmail();
        if (val) {
            setErrorBusinessInfo({});
            setCentredModal1(true);
            setEmailVerify(true);
            await sendEmailVerify(e);
        }
    };
    const sendEmailVerify = async (e) => {
        e.preventDefault();
        const value = await sendVEmail(JSON.parse(localStorage.getItem("loggedUserInfo"))?._id);
        setError("Email sent Successfully");
        return;
    }
    let planAmount = (currentPlan?.billingperiod ? (currentPlan?.billingperiod.find((obj) => obj.duration == Form.subscriptionfrequency)?.montly) || 0 : 0);
    return (
        <>
            <div className="pay_container">
                <div className="container paycontent bg-white rounded shadow-2">
                <div className="border-bottom">
                        <div className="py-2 px-4 d-flex align-items-center justify-content-between w-100">
                        <h4 className="m-0">Payment Billing Details </h4>
                        <div className='d-flex flex-wrap mb-3 w-15'>
                            {businessForm.istesting == true ?
                                <p className="expiry mx-1 mb-0 title chip bg-info bg-opacity-50">
                                    Test Account
                                </p> : null}
                        </div>
                        <img
                            src={easymembr}
                            className="logoImg"
                            alt="Gym Logo"
                        />
                    </div>
                </div>

                    <div className="p-4 paymet_body">
                        <div className="Billing__Address mob-w-100 ">
                            <MDBRow>
                                <MDBCol size={12}>
                                    <p className="mb-2 fw-bold label-color">User Details</p>
                                </MDBCol>
                                <MDBCol sm={12} md={4}>
                                    <div class="mb-3">
                                        <label class="form-label mb-0">First Name <span className="text-danger">*</span></label>
                                        <input type="text" class="form-control form-control-lg" name="first_name" id="first_name" placeholder="First Name" value={businessForm.firstName}
                                            onChange={(e) => updateBusinessForm({ firstName: e.target.value })} />
                                        {ErrorBusinessInfo.firstName && (<p className="clr-red">{ErrorBusinessInfo.firstName}</p>)}
                                    </div>
                                </MDBCol>

                                <MDBCol sm={12} md={4}>
                                    <div class="mb-3">
                                        <label class="form-label mb-0">Last Name <span className="text-danger">*</span></label>
                                        <input type="text" class="form-control form-control-lg" name="first_name" id="first_name" placeholder="Last Name" value={businessForm.lastName}
                                            onChange={(e) => updateBusinessForm({ lastName: e.target.value })} />
                                        {ErrorBusinessInfo.lastName && (<p className="clr-red">{ErrorBusinessInfo.lastName}</p>)}
                                    </div>
                                </MDBCol>
                                <MDBCol sm={12} md={4}>
                                    <div className="d-flex align-items-center">
                                        <div class="mb-3 flex-1 position-relative">
                                            <label class="form-label mb-0">Email ID <span className="text-danger">*</span></label>
                                            <input type="text" class="form-control form-control-lg" name="first_name" id="first_name" placeholder="Email ID"
                                                value={businessForm.businessEmail}
                                                onChange={(e) => { updateBusinessForm({ businessEmail: e.target.value, isemailverified: false }); setEmailVerify(false) }} />
                                            {emailVerify && <MDBIcon fas icon="clock" color="warning" size="xl" className="check-btn" />}

                                            {businessForm.isemailverified &&
                                                <>
                                                    <MDBIcon fas icon="check-circle" color="success" size="xl" className="check-btn" />
                                                    <span className="text-success d-block text-right verifytext" >Verified</span>
                                                </>}

                                            {ErrorBusinessInfo.businessEmail && (<p className="clr-red">{ErrorBusinessInfo.businessEmail}</p>)}
                                        </div>
                                        {(!businessForm.isemailverified && !emailVerify) && (localStorage.getItem("loggedUserInfo")) &&
                                            <MDBBtn size='sm' className="p-2 ms-2 fw-bold" onClick={(e) => emailVerifyHandler(e)}>Verify</MDBBtn>}
                                    </div>
                                </MDBCol>

                                <MDBCol sm={12} md={4} className="mb-2">
                                    <div className="align-items-center">
                                        <div class="mb-3 position-relative">
                                            <label class="form-label mb-0">Mobile Number <span className="text-danger">*</span></label>
                                            <PhoneInput
                                                className=" New_business_input gym-input d-flex select_country"
                                                defaultCountry="IN"
                                                placeholder="Mobile Number"
                                                value={businessForm.contactNumber}
                                                // disabled={userExist}
                                                // onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                                onChange={(value) => updateBusinessForm({ contactNumber: value, isnumberverified: false })}
                                            />
                                            {businessForm.isnumberverified && <><MDBIcon fas icon="check-circle" color="success" size="xl" className="check-btn" />
                                                <span className="text-success d-block text-right verifytext" >Verified</span></>}
                                            {ErrorBusinessInfo.contactNumber && (<p className="clr-red">{ErrorBusinessInfo.contactNumber}</p>)}
                                            {ErrorBusinessInfo.verify && (<p className="clr-red">{ErrorBusinessInfo.verify}</p>)}
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                </MDBCol>

                                {!businessForm.isnumberverified && <MDBCol sm={12} md={4} className="mb-2">
                                    <label class="form-label mb-0"></label>
                                    <div className="flex-1 position-relative d-flex">
                                        <MDBBtn size='sm' className="p-2 fw-bold" onClick={(e) => handleOtp(e)}>Verify</MDBBtn>
                                    </div>
                                </MDBCol>}

                                <MDBCol size={12}>
                                    <p className="mb-2 fw-bold label-color">Billing Details</p>
                                </MDBCol>

                                <MDBCol sm={12} md={8}>
                                    <div class="mb-3">
                                        <label class="form-label mb-0">Business Name <span className="text-danger">*</span></label>
                                        <input type="text" class="form-control form-control-lg" name="first_name" id="first_name" placeholder="Business Name"
                                            value={businessForm.businessName}
                                            onChange={(e) => updateBusinessForm({ businessName: e.target.value })} />
                                        {ErrorBusinessInfo.businessName && (<p className="clr-red">{ErrorBusinessInfo.businessName}</p>)}
                                    </div>
                                </MDBCol>
                                <MDBCol sm={12} md={4}>
                                    <div class="mb-3">
                                        <label class="form-label mb-0">City <span className="text-danger">*</span></label>
                                        <input type="text" class="form-control form-control-lg" name="first_name" id="first_name" placeholder="City"
                                            value={businessForm.city}
                                            onChange={(e) => updateBusinessForm({ city: e.target.value })} />
                                        {ErrorBusinessInfo.city && (<p className="clr-red">{ErrorBusinessInfo.city}</p>)}
                                    </div>
                                </MDBCol>
                                <MDBCol size={12}>
                                    <div class="mb-3">
                                        <label class="form-label mb-0">Address <span className="text-danger">*</span></label>
                                        <textarea class="form-control form-control-lg" rows="1" name="first_name" id="first_name" placeholder="Address"
                                            value={businessForm.address}
                                            onChange={(e) => updateBusinessForm({ address: e.target.value })}></textarea>
                                        {ErrorBusinessInfo.address && (<p className="clr-red">{ErrorBusinessInfo.address}</p>)}
                                    </div>
                                </MDBCol>

                            </MDBRow>
                        </div>

                        <div className="summary_content mt-2">
                            <MDBRow>
                                <MDBCol size={12} md={7}>
                                    <MDBRow>
                                        <MDBCol size={12}>
                                            <p className="mb-2 fw-bold label-color">Order Summary</p>
                                        </MDBCol>
                                        <MDBCol sm={12} md={12}>
                                            <MDBTable className="summary_tabel">
                                                <MDBTableHead>
                                                    <tr>
                                                        <th scope='col'>Plan Details</th>
                                                        <th scope='col'>Duration</th>
                                                        <th scope='col'>Price</th>

                                                    </tr>
                                                </MDBTableHead>
                                                <MDBTableBody>
                                                    <tr>
                                                        <td scope='row'>
                                                            <div className="plan_content d-flex align-items-center">
                                                                <div className="plan_pic me-2">
                                                                    <img src={membrmanage} alt="" />
                                                                </div>
                                                                <div className="tagname">
                                                                    <p className="m-0">{currentPlan?.name}
                                                                        {/* <label className="link-color text-end" onClick={() => navigate('/commercials')}>Change plan</label> */}
                                                                    </p>
                                                                    <span className="text-secondary">Easy to get started, simple to use system</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{Form.lifetimefree ? "Free" : <>{Form.subscriptionfrequency} Months</>}</td>
                                                        <td>&#8377;{(planAmount * Form.subscriptionfrequency) % 1 === 0 ? (planAmount * Form.subscriptionfrequency) : (planAmount * Form.subscriptionfrequency).toFixed(2)}</td>
                                                    </tr>
                                                    {!Form.lifetimefree &&
                                                        <tr>
                                                        <td colSpan={3}>
                                                            <div className="plantoster">
                                                                <div className="planicon d-flex align-items-center justify-content-center">
                                                                    <i class="fas fa-hand-holding-heart"></i>
                                                                </div>
                                                                <div className="p-2 planmessg">
                                                                        {extenddays > 0 && (selectedOption == 1 ?
                                                                            <label className="m-0">Your previous plan will remain active for {Math.floor(extenddays)} more day(s).</label>
                                                                            :
                                                                            <label className="m-0">You’ve earned {Math.floor(extenddays)} additional day(s) carried over from your previous plan.</label>
                                                                        )}
                                                                    <p className="m-0"> The new plan will start on {formattedStartDate} and continue until {formattedExpiryDate}.</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        </tr>}
                                                </MDBTableBody>
                                            </MDBTable>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                                <MDBCol size={12} md={5}>
                                    <MDBRow>
                                        <MDBCol size={12}>
                                            <p className="mb-2 fw-bold label-color">Payment Summary</p>
                                        </MDBCol>
                                        <MDBCol sm={12} md={12}>
                                            <div className="paysummary p-3">

                                                {/* Coupon Toggle */}
                                                {!coupon.couponApplied ? (
                                                    <>
                                                        {!coupon.showInput && Form.amount > 0 && 
                                                            <div className="mb-3">
                                                                <MDBBtn
                                                                    outline
                                                                    color="primary"
                                                                    size="lg"
                                                                    className="w-100 copun-btn"
                                                                    onClick={() =>
                                                                        setCoupon({ ...coupon, showInput: !coupon.showInput })
                                                                    }
                                                                >
                                                                    <i class="fas fa-tags me-1"></i>  Do You Have Coupon?
                                                                </MDBBtn>
                                                            </div>}
                                                    </>
                                                ) : (<div className="mb-3 ">
                                                    <div className="d-flex align-items-center justify-content-between" >
                                                        <div className="bg-light py-1 px-2 border flex-grow-1 rounded-start">
                                                            <div className=" ">
                                                                <span className="fw-bold text-success">
                                                                        {coupon.couponCode}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <MDBBtn
                                                                size="sm"
                                                                color="danger"
                                                                className="fw-bold copun-applybtn border-1"
                                                                onClick={() =>
                                                                    setCoupon({
                                                                        ...coupon,
                                                                        couponCode: "",
                                                                        couponApplied: false,
                                                                        couponError: "",
                                                                        discountPercentage: 0,
                                                                        showInput: false,
                                                                        extraDays: 0,
                                                                    })
                                                                }
                                                            >
                                                                Remove
                                                            </MDBBtn>
                                                        </div>
                                                        <span className="text-success fw-bold  ps-1" style={{ fontSize: '12px' }}> {coupon.extraDays} Days Free + {coupon.discountPercentage}% off applied</span>
                                                    </div>
                                                )}

                                                {/* Coupon Input */}
                                                {coupon.showInput && !coupon.couponApplied && (
                                                    <div className="d-flex align-items-center">
                                                        <input
                                                            type="text"
                                                            className="form-control copun-apply"
                                                            placeholder="Enter Coupon Code"
                                                            value={coupon.couponCode}
                                                            onChange={(e) =>
                                                                setCoupon({ ...coupon, couponCode: e.target.value })
                                                            }
                                                        />
                                                        <MDBBtn
                                                            size="sm"
                                                            color="primary"
                                                            className="copun-applybtn"
                                                            onClick={() => applyCoupon()}
                                                        >
                                                            Apply
                                                        </MDBBtn>
                                                    </div>
                                                )}
                                                {coupon.couponError && (
                                                    <p className="text-danger">{coupon.couponError}</p>
                                                )}
                                                {/* Payment Details */}
                                                <p className="bold  mt-3">
                                                    Payment Details
                                                </p>
                                                <div className="d-flex w-100 mb-3">
                                                    <label className=" w-30 fw-bold" >Total</label>
                                                    <label className=" w-70 text-end">{(Form.amount - finalAmount) > 0 &&
                                                        <del className="me-1">&#8377;{Form.amount % 1 === 0 ? Form.amount : Form.amount.toFixed(2)}</del>} &#8377;{finalAmount % 1 === 0 ? finalAmount : finalAmount.toFixed(2)}
                                                    </label>

                                                    {(Form.amount - finalAmount) > 0 && (
                                                        <MDBTooltip
                                                            tag="span"
                                                            title={
                                                                <div style={{ textAlign: "left" }}>
                                                                    <div>Actual Amount: <strong>₹{Form.amount}</strong></div>
                                                                    <div>Discount: <strong>{coupon.discountPercentage}%</strong></div>
                                                                    <div>Final Amount: <strong>₹{finalAmount}</strong></div>
                                                                </div>
                                                            }
                                                        >
                                                            <MDBIcon fas icon="info-circle" className="ms-2 text-primary" />
                                                        </MDBTooltip>

                                                    )}
                                                </div>

                                                <div className="d-flex w-100 align-items-center justify-content-between mb-3">
                                                    <label className="fw-bold">GST 18%</label>
                                                    <label className=" w-40 text-end">&#8377;{(finalAmount * 0.18).toFixed(2)}</label>
                                                </div>
                                                <div className="mb-3">

                                                    <div className="d-flex w-100 align-items-center justify-content-between">
                                                    <label className="fw-bold text-dark">Grand Total</label>
                                                        <label className="fw-bold text-dark text-end">{prevBalanceAmount > 0 &&
                                                            <del className="me-1">&#8377;{totalAmount.toFixed(2)}</del>} &#8377;{Math.round(payAmount)}

                                                            {prevBalanceAmount > 0 && (
                                                                <MDBTooltip
                                                                    tag="span"
                                                                    placement="top"
                                                                    title={
                                                                        <div style={{
                                                                            textAlign: "left",
                                                                            minWidth: "175px",
                                                                            lineHeight: "1.5",
                                                                            fontSize: "14px"
                                                                        }}>
                                                                            <div style={{ fontWeight: "600", marginBottom: "4px" }}>Existing summary</div>
                                                                            <div style={{ marginBottom: "8px", display: "flex", justifyContent: "space-between" }}>
                                                                                <span>Balance:</span>
                                                                                <span style={{ fontWeight: "500", textAlign: "right", marginLeft: "8px" }}>
                                                                                    ₹{(balAmnt > 0 ? balAmnt : prevBalanceAmount).toFixed(2)}
                                                                                </span>
                                                                            </div>
                                                                            <div style={{ fontWeight: "600", marginBottom: "4px" }}>New summary</div>
                                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <span>Price:</span>
                                                                                <span style={{ fontWeight: "500", textAlign: "right", marginLeft: "8px" }}>
                                                                                    ₹{payAmount.toFixed(2)}
                                                                                </span>
                                                                            </div>
                                                                            <div className="text-end text-white d-block">
                                                                                <del style={{ textAlign: "right", }} >₹{totalAmount.toFixed(2)}</del>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                >
                                                                    <MDBIcon fas icon="info-circle" className="ms-2 text-primary" />
                                                                </MDBTooltip>

                                                            )}
                                                        </label>

                                                    </div>
                                                    {prevBalanceAmount > 0 && <span className="text-success fw-bold d-block ps-1" style={{ fontSize: '12px', textAlign: "right", }}> Amount adjusted based on your previous plan</span>}
                                                </div>

                                                <div className="d-flex w-100 align-items-start justify-content-end mt-3">
                                                    <MDBBtn color='secondary' className="me-3 fw-bold" onClick={() => { navigate(-1) }}>Cancel</MDBBtn>
                                                    <MDBBtn className="fw-bold" onClick={async (e) => { if (await checkingEmail()) { payNow(e) } }}>
                                                        {((Math.round(payAmount) <= 0) || Form.paylater) ? "Continue" : "Pay"}</MDBBtn>
                                                </div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                            </MDBRow>
                        </div>


                    </div >
                </div >
                {error && <MDBAlert
                    color={error.toLowerCase().includes('success') ? 'success' : 'danger'}
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={error}
                    onClose={() => { setError(null) }}
                    style={{ zIndex: 9999 }}
                >
                    {error}
                </MDBAlert>
                }
                {centredModal && (<>
                    <Popup
                        title="Mobile Number Verification"
                        ptype="modal-md"
                        style=""
                        content={
                            <div className='text-center'>
                                <p>We've sent a One Time Password (OTP) to your mobile number <br />
                                    <strong>{businessForm.contactNumber || "+91XXXXXXXXXX"}</strong>
                                </p>

                                <p className="mb-3">Please enter the 6-digit OTP below to verify your number.</p>

                                <div className="d-flex justify-content-center gap-2 mb-3">
                                    {[...Array(6)].map((_, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength={1}
                                            className="form-control text-center"
                                            style={{ width: "40px", fontSize: "1.2rem" }}
                                            value={otpDigits[index]}
                                            onChange={(e) => handleOtpChange(e, index)}
                                            onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                        />
                                    ))}
                                </div>

                                <p className="text-muted">
                                    Resend OTP in <strong>{resendTimer > 0 ? `00:${resendTimer.toString().padStart(2, '0')}` :
                                        <label onClick={(e) => otpfield(e)} className='button-link fw-600 text-primary fs-14px'>Now</label>}</strong>
                                </p>

                                <MDBBtn block className="mt-2" onClick={(e) => handleVerifyOTP(e)}>
                                    Verify OTP
                                </MDBBtn>
                            </div>
                        }
                        handleClose={() => setCentredModal(false)}
                    />
                </>
                )}
                {centredModal1 && (<>
                    <Popup
                        title="Email Verification"
                        ptype="modal-md"
                        style=""
                        content={
                            <div className="text-center">
                                <label>
                                    We’ve sent a confirmation link to your registered email address<br />
                                    <strong>{businessForm.businessEmail || "your-email@example.com"}</strong>
                                </label>

                                <p className="my-3 fs-14px">
                                    Please check your inbox and click the link to verify your email address.
                                    <br />
                                    If you don’t see the email, check your spam or junk folder.
                                </p>

                                <p className="text-muted">
                                    Didn’t receive the email?{" "}
                                    <label onClick={(e) => sendEmailVerify(e)} className="button-link fw-600 text-primary fs-14px">
                                        Resend Now
                                    </label>
                                </p>

                                <MDBBtn block className="mt-2" onClick={() => setCentredModal1(false)}>
                                    Close
                                </MDBBtn>
                            </div>
                        }
                        handleClose={() => setCentredModal1(false)}
                    />
                </>
                )}
                {plansData.length > 0 &&
                    <PlanPopup
                    close={() => setCentredModal2(false)}
                        show={centredModal2}
                        currentPlan={planId != null ? currentPlan : null}
                        allPlans={plansData}
                        selectPlan={selectPlan}
                    />}
                {loading &&
                    <div className="page-loader w-100 h-100">
                        <div className="p-3 bg-light rounded-3 d-flex align-items-center justify-content-center flex-column" >
                            <MDBSpinner className='loading-icon' color="dark" role='status' />
                            <p className="m-0 pt-2" style={{ fontWeight: 500 }}>{totalAmount <= 0 ? " " : "Creating payment."} Please wait...</p>
                        </div>
                    </div>}
                <div className="text-center d-block text-secondary mt-1 py-1">Powered by Zencruz</div>
            </div>
        </>
    );
}
